import { useEffect, useState } from "react";
import { collection, query, orderBy, onSnapshot } from "firebase/firestore";
import { db } from "@/lib/firebase";
import type { Member } from "@/lib/types";

export interface Invite {
  id: string;
  email: string;
  role: string;
  teams: string[];
  status: "pending" | "accepted" | "revoked";
  token: string;
  invitedByName: string;
  createdAt: any;
}

export function useMembers(clubId: string | undefined) {
  const [members, setMembers] = useState<(Member & { id: string })[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!clubId) { setMembers([]); setLoading(false); return; }
    const unsub = onSnapshot(
      query(collection(db, "clubs", clubId, "members"), orderBy("joinedAt", "desc")),
      (snap) => {
        setMembers(snap.docs.map((d) => ({ id: d.id, ...d.data() })) as any);
        setLoading(false);
      }
    );
    return unsub;
  }, [clubId]);

  return { members, loading };
}

export function useInvites(clubId: string | undefined) {
  const [invites, setInvites] = useState<Invite[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!clubId) { setInvites([]); setLoading(false); return; }
    const unsub = onSnapshot(
      query(collection(db, "clubs", clubId, "invites"), orderBy("createdAt", "desc")),
      (snap) => {
        setInvites(snap.docs.map((d) => ({ id: d.id, ...d.data() })) as any);
        setLoading(false);
      }
    );
    return unsub;
  }, [clubId]);

  const pending = invites.filter((i) => i.status === "pending");
  return { invites, pending, loading };
}
